const doubleBoxMainProp = document.querySelectorAll('.double-box__main-prop');

if (doubleBoxMainProp.length) {
  window.addEventListener('scroll', () => {
    doubleBoxMainProp.forEach((item) => {
      const itemSlave = item.querySelector('.double-box__main-prop-slave');
      const itemMaster = item.querySelector('.double-box__main-prop-master');

      if (itemSlave.getBoundingClientRect().top - window.screen.height * 0.30 < 0) {
        itemSlave.classList.add('active');
        itemMaster.classList.remove('active');
      } else {
        itemSlave.classList.remove('active');
        itemMaster.classList.add('active');
      }
    });
  });
}
